import React from "react";
import styled from "@emotion/styled/macro";
import { tokens, Typography } from "@sunrun/experience-ui-components";

type ResponseListOption = {
  label: string;
  value: string;
};

type RadioButtonGroupProps = {
  options: ResponseListOption[];
  value: string;
  onChange: (value: string) => void;
  layout: "column" | "row";
  name: string;
};

const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({
  options,
  value,
  onChange,
  layout,
  name,
}) => {
  return (
    <RadioGroupContainer layout={layout}>
      {options.map((option) => (
        <RadioOption key={option.value}>
          <RadioInput
            type="radio"
            id={`${name}-${option.value}`}
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={(e) => onChange(e.target.value)}
            data-testid={`radio-${name}-${option.value}`}
          />
          <RadioLabel htmlFor={`${name}-${option.value}`}>
            <Typography variant="span">{option.label}</Typography>
          </RadioLabel>
        </RadioOption>
      ))}
    </RadioGroupContainer>
  );
};

const RadioGroupContainer = styled.div<{
  layout: "column" | "row";
}>`
  display: flex;
  flex-direction: ${({ layout }) => (layout === "column" ? "column" : "row")};
  gap: ${({ layout }) => (layout === "column" ? "12px" : "16px")};
  flex-wrap: ${({ layout }) => (layout === "row" ? "wrap" : "nowrap")};
`;

const RadioOption = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const RadioInput = styled.input`
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: ${tokens.BRAND_HEROBLUE};
  flex-shrink: 0;
`;

const RadioLabel = styled.label`
  cursor: pointer;
  display: flex;
  align-items: center;
  user-select: none;
`;

export { RadioButtonGroup };
export type { RadioButtonGroupProps };
